/**
 * Default FAQ content used to seed Firestore on first run.
 * All fields are plain strings. Answers can include HTML (e.g. <br/>, <ul>, <a>).
 * answerEvening is optional; when missing, evening guests see the same as day.
 */
export const defaultFaqItems = [
  {
    question: "What time should I arrive?",
    answer: "The ceremony will begin at 1:00pm. We kindly ask guests to arrive between 12:00pm and 12:30pm."
  },
  {
    question: "What is the dress code?",
    answer: "Formal attire. Please avoid wearing ivory or dusty blue, as these colours will be worn by our bridal party."
  },
  {
    question: "Is the ceremony indoors or outdoors?",
    answer: "Weather permitting, we are hoping to hold our ceremony outdoors."
  },
  {
    question: "How and when should I RSVP?",
    answer: "Please RSVP by 27th March 2026.<br /><br />You can respond and submit your menu choices via:<br />• Our wedding website<br />• The RSVP card<br />• Messaging Kerry or Mike directly"
  },
  {
    question: "Is parking available?",
    answer: "Yes, there is plenty of free on-site parking available. Cars may be left overnight at the owner's own risk."
  },
  {
    question: "Are children invited?",
    answer: "Absolutely! We couldn't imagine our special day without them.<br /><br />We kindly ask that guests with babies or young children choose seating that allows for an easy and discreet exit if needed. We completely understand that little ones can sometimes become restless or noisy. If this happens during the ceremony or speeches, we'd really appreciate you stepping away from the ceremony area with them until they're settled, thank you for helping us keep these moments special.<br /><br />One small note: for everyone's safety and comfort, prams will need to remain outside of the wedding breakfast area during the meal and speeches. Babies are, of course, very welcome to sit on your lap."
  },
  {
    question: "Can I bring a plus one?",
    answer: "Unfortunately, only guests named on the invitation are able to attend."
  },
  {
    question: "Is there a gift registry?",
    answer: 'Your presence on our special day truly means the world to us. However, if you would like to give a gift, we have a gift list available at <a href="https://prezola.com/buy/view/272530" target="_blank" rel="noopener noreferrer" style="color:#fff;text-decoration:underline;font-weight:bold">Prezola</a>, or a contribution towards our family-moon would be greatly appreciated.'
  },
  {
    question: "Can I take photos?",
    answer: "We will have professional photographers and videographers capturing our ceremony, so we kindly ask that you refrain from taking photos during this time.<br /><br />Once the ceremony has finished, please feel free to snap away! We just ask that no photos are shared on social media until we have posted our first photo as Mr & Mrs Stow.<br /><br />We'd love to see your pictures - these can be uploaded via our wedding website or sent to us on WhatsApp."
  },
  {
    question: "Do I need to bring cash?",
    answer: "Our Venue does not accept cash, so please ensure you have a card with you. AMEX is not accepted at the venue."
  },
  {
    question: "Can I bring confetti?",
    answer: "We will be providing confetti to ensure we comply with our venue's rules."
  }
];

export const defaultTransport = {
  title: "Transport",
  description: "If taxis are needed, the venue recommends the following companies:",
  companies: [
    { name: "Mayflower", phone: "01277 623000" },
    { name: "Swift", phone: "01277 757575" }
  ]
};
